import { ToggleMarkPlugin } from "@udecode/plate"
import { createBoldPlugin } from "@udecode/plate-basic-marks"

import Bold from "../components/Bold"
import { MyEditor, MyValue } from "../types"

export const boldPlugin = createBoldPlugin<ToggleMarkPlugin, MyValue, MyEditor>(
  { component: Bold }
)
